import { useEffect, useRef } from 'react';
import useNavParams from './useNavParams';

const useSubNavigation = <T>(
  defaultPage: T & (string | number),
  key = 'page',
  onPageChange?: (page: T) => void
) => {
  const isInitialMount = useRef<boolean>(true);
  const { params, setParams } = useNavParams();
  const activePage = (params?.[key] as T & (string | number)) || defaultPage;

  const setPage = (
    page: T & (string | number),
    params?: Record<string, string>,
    blockRefresh?: boolean
  ) => {
    // Only notify when the hash write landed - a dropped write means we are no
    // longer on this hook's route, so the page never changed (#2145).
    if (setParams({ [key]: page.toString(), ...params }, blockRefresh)) {
      onPageChange?.(page);
    }
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    setPage(activePage ? activePage : defaultPage);
  }, [params]);

  return {
    activePage,
    setPage,
    params
  };
};

export default useSubNavigation;
